import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';

interface CloseEvent {
  reason: string | null;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomerBookingDeclineModal',
  props: {
    disabled: { type: Boolean }
  },
  emits: ["decline"],
  setup(__props: any, { emit }: { emit: ({
  (event: 'decline', value: CloseEvent): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  disabled: boolean;
}




const isOpen = ref<boolean>(false);
const selectedReason = ref<string | null>(null);
const reasons = ref<string[]>([
  'Fixed it themselves',
  'No reason given',
  'No Landlord Permission',
  'Customer not ready for appt',
  'No show- customer',
  'Pricing issue',
  'Went with another company',
  'Clerical error',
  'DNS Customer',
  'Scheduling conflict (tech side)',
]);

function decline() {
  emit('decline', {
    reason: selectedReason.value,
  });
}
function open() {
  isOpen.value = true;
}

function close() {
  selectedReason.value = null;
  isOpen.value = false;
}

return { __sfc: true,props, emit, isOpen, selectedReason, reasons, decline, open, close }
}

})